import { InfoDialogPlugin } from '@/plugins/GlobalDialog';

export default class InfoDialogModel {
  public show(message: string, onConfirm: VoidFunction|false = false): void {
    InfoDialogPlugin.$eventBus.$emit('show-info-dialog', {
      message,
      onConfirm,
    })
  }
}
